import axiosPrivate from "../../../api/axiosPrivate";
import { GET_DASH_DETAILS, GET_LOGGEDIN_USERS } from "../../../api/constant";

// Get dashboard details
const getDashStats = async ({office_id, policy_type}) => {
  const response = await axiosPrivate.get(
    `${GET_DASH_DETAILS}?office_id=${office_id}&policy_type=${policy_type}`
  );
  return response.data;
};
const getLoggedInUsers = async (office_id) => {
  const response = await axiosPrivate.get(
    `${GET_LOGGEDIN_USERS}?office_id=${office_id}`
  );
  return response.data;
};

const dashService = {
  getDashStats,
  getLoggedInUsers,
};

export default dashService;
